module.exports = __webpack_public_path__ + "img/volunteer-2.bc046a17.jpg";